import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import { useFetchServiceCenters } from '@webplatform/nuxt-cms-js-sdk';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCenters',
  setup(__props) {

const {
  $api: { serviceCentersService, countriesService, citiesService },
} = useContext();
const countries = ref([]);
const cities = ref([]);
const selectedCountry = ref<any>(null);
const selectedCity = ref<any>(null);
const activeMarker = ref<any>(null);
const citiesLoading = ref(false);
const setActiveMarker = (i: any) => {
  activeMarker.value = i;
};

const { centers, fetchServiceCenters } = useFetchServiceCenters({
  limit: 9999,
});

const fetchCountries = async () => {
  try {
    const { data: servicesData } =
      await serviceCentersService.getServicesCountriesIds();
    const { data: countriesData } = await countriesService.getCountriesByIds({
      country_id: servicesData.map((s: any) => s.id),
      limit: 1000,
    });
    countries.value = countriesData;
  } catch (error) {}
};

const fetchCities = async (countryId: string) => {
  try {
    citiesLoading.value = true;
    const { data: servicesData } =
      await serviceCentersService.getServicesCitiesByCountryId(countryId);
    const { data: citiesData } = await citiesService.getCitiesByIds({
      city_id: servicesData.map((s: any) => s.id),
    });
    cities.value = citiesData;
  } catch (error) {
    console.log(error);
  } finally {
    citiesLoading.value = false;
  }
};

const filterHours = (hours: any) => {
  return hours.filter((hour: any) => hour.start !== null && hour.end !== null);
};

const serviceCenters = computed(() => {
  const result: any[] = [];
  centers.value.forEach((s) => {
    s.addresses.forEach((address) => {
      result.push({
        name: s.name,
        url: address.url,
        address: address.address,
        phones: address.phones,
        lat: Number(address.lat),
        lng: Number(address.lon),
        countryId: address.country_id,
        cityId: address.city_id,
        working_hours: filterHours(address.working_hours),
      });
    });
  });

  return result;
});

const citiesSelectDisable = computed(
  () =>
    selectedCountry.value === null ||
    citiesLoading.value ||
    (!citiesLoading.value && !cities.value.length),
);

const filteredServiceCenters = computed(() => {
  let result = [];
  if (selectedCountry.value !== null && !selectedCity.value) {
    result = serviceCenters.value.filter(
      (s) => selectedCountry.value === s.countryId,
    );
  } else if (selectedCity.value !== null) {
    result = serviceCenters.value.filter(
      (s) => selectedCity.value === s.cityId,
    );
  } else {
    result = serviceCenters.value;
  }
  return result;
});

const activeService = computed(
  () => filteredServiceCenters.value[activeMarker.value],
);

const markers = computed(() =>
  filteredServiceCenters.value.map((s) => {
    return {
      title: s.name,
      position: {
        lat: s.lat,
        lng: s.lng,
      },
    };
  }),
);

watch(selectedCountry, (newValue) => {
  selectedCity.value = null;
  activeMarker.value = null;
  fetchCities(newValue as any);
});

watch(selectedCity, () => {
  activeMarker.value = null;
});

onMounted(() => {
  fetchServiceCenters();
  fetchCountries();
});

return { __sfc: true,serviceCentersService, countriesService, citiesService, countries, cities, selectedCountry, selectedCity, activeMarker, citiesLoading, setActiveMarker, centers, fetchServiceCenters, fetchCountries, fetchCities, filterHours, serviceCenters, citiesSelectDisable, filteredServiceCenters, activeService, markers }
}

})